import { useState } from "react";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { verifyAdmin, errorText } from "@/lib/api";

export const AdminGate = ({ onUnlock }) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await verifyAdmin(value);
      await onUnlock(value);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} key={error} className={`mt-10 max-w-md rounded-2xl border-2 border-amber-400/50 bg-[#161926] p-8 ${error ? "shake" : ""}`} data-testid="admin-gate">
      <Lock className="mb-4 h-8 w-8 text-amber-400" />
      <label className="text-sm text-slate-300" htmlFor="admin-pw">Admin password</label>
      <Input id="admin-pw" type="password" value={value} onChange={(e) => setValue(e.target.value)} data-testid="admin-password-input" className="mt-2 border-slate-600 bg-[#0d0f17] text-white" autoFocus />
      {error && <p className="mt-3 text-sm text-rose-400" data-testid="admin-login-error">{error}</p>}
      <button type="submit" disabled={busy || !value} data-testid="admin-login-button" className="show-btn mt-6 w-full rounded-full py-3 font-bold text-white disabled:opacity-60">
        {busy ? "Checking..." : "Enter"}
      </button>
    </form>
  );
};
